import image1 from "./assets/carouselImage1.jpg";
import image2 from "./assets/carouselImage2.jpg";
import image3 from "./assets/carouselImage3.jpg";
import image4 from "./assets/carouselImage4.jpg";
import image5 from "./assets/carouselImage5.jpg";
import image6 from "./assets/carouselImage6.jpg";

import multicar1 from "./assets/multicar1.jpeg";
import multicar2 from "./assets/multicar2.jpeg";
import multicar3 from "./assets/multicar3.jpeg";
import multicar4 from "./assets/multicar4.jpeg";
import multicar5 from "./assets/multicar5.jpeg";
import multicar6 from "./assets/multicar6.jpeg";
import multicar7 from "./assets/multicar7.jpeg";
import multicar8 from "./assets/multicar8.jpeg";
import multicar9 from "./assets/multicar9.jpeg";
import multicar10 from "./assets/multicar10.jpeg";
import multicar11 from "./assets/multicar11.jpeg";

export const dataa = [image1, image2, image3, image4, image5, image6];
export const multiData = [
  multicar1,
  multicar10,
  multicar2,
  multicar3,
  multicar11,
  multicar4,
  multicar5,
  multicar9,
  multicar6,
  multicar7,
  multicar8,
];
